import { jwtDecode } from 'jwt-decode';

// The session lives exactly as long as the refresh token. The access token is
// short-lived and expected to lapse mid-session: the 401 → refresh path renews it,
// so its expiry must never decide whether the user is logged in.

/** Whether a refresh token is stored and has not yet expired. */
export function hasLiveRefreshToken(): boolean {
  const refreshToken = sessionStorage.getItem('refresh');
  if (!refreshToken) return false;
  try {
    const { exp } = jwtDecode<{ exp?: number }>(refreshToken);
    return typeof exp === 'number' && exp * 1000 > Date.now();
  } catch {
    return false;
  }
}
